export default "/images/co-img-3.png?b71f0e06b01a37c478dcb78694cd81f7";